import React, { Component } from "react";
import TitleWithControl from "../../ComponentsPedidos/TitleWithControl.js";
import ButtonContinue from "../../ComponentsPedidos/ButtonContinue.js";
import {
  BillingProductsContainer,
  BillingProductsContainerContent,
  BillingProductsContainerContentColumnConfig,
  BillingProductsContainerContentColumnConfigCel,
  BillingProductsContainerContentColumnConfigCelConfig,
  BillingProductsContainerContentColumnConfigCelConfigMargin,
  BillingProductsContainerContentColumnConfigCelConfigTable,
  BillingProductsContainerContentColumnConfigCelConfigTableControlQuantidade,
  BillingProductsContainerContentColumnConfigCelDouble,
  BillingProductsContainerContentColumnInfoTable,
  BillingProductsContainerContentColumnProduct,
  BillingProductsContainerContentColumnProductCel,
  BillingProductsContainerContentColumnProductCelDouble,
  BillingProductsContainerContentColumnProductCelProd,
  BillingProductsContainerContentColumnProductCelProdDesc,
  BillingProductsContainerContentColumnProductCelProdImage,
  BillingProductsContainerContentColumnProductInfo,
  BillingProductsContainerContentColumnProductInfoTitle,
  BillingProductsContainerContentColumnView,
  BillingProductsContainerContentColumnViewCel,
  BillingProductsContainerContentColumnViewCelDouble,
  BillingProductsContainerContentColumnViewCelPDF,
  BillingProductsContainerContentColumnViewCelPDFContent,
} from "./styles.js";
import { Box } from "@chakra-ui/react";

class BillingProducts extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data_product: this.props.data_request,
      data_proposal_original: this.props.data_proposal_original,
      billing_type_more_than_one: this.props.billing_type_more_than_one,
      index_request: this.props.index_request,
    };
  }

  componentDidMount() {
    // if(!this.props.billing_type_more_than_one){
    //     this.state.data_proposal_original.map(item=>{
    //         item.select_amount = parseInt(item.total_amount);
    //         // item.remaining_amount = 0
    //     })
    //     this.setState({update:true});
    // // }
    // console.log(this.state.data_product);
    // console.log(this.state.data_proposal_original);
    // console.log(this.state.billing_type_more_than_one);
  }

  setMoreAmount = (e) => {
    var data = JSON.parse(e.target.attributes.data.value);

    if (this.state.billing_type_more_than_one) {
      this.state.data_product.map((item) => {
        if (
          item.codigo_produto == data.codigo_produto &&
          item.sequencia == data.sequencia &&
          item.tipo_produto == "PROD"
        ) {
          if (parseInt(item.select_amount) < parseInt(item.total_amount)) {
            item.select_amount = parseInt(item.select_amount) + 1;
            item.remaining_amount = parseInt(item.remaining_amount) - 1;

            this.state.data_product.map((obj) => {
              if (
                obj.tipo_produto == "EMB" &&
                obj.token_embalagem == item.token_embalagem
              ) {
                obj.select_amount = parseInt(item.select_amount) + 1;
                obj.remaining_amount = parseInt(item.remaining_amount) - 1;
              }
            });
          }
        }
      });
      this.setState({ update: true });
    }
    this.props.updated_item();
  };

  setAmount = (e) => {
    var data = JSON.parse(e.target.attributes.data.value);

    if (this.state.billing_type_more_than_one) {
      this.state.data_product.map((item) => {
        if (
          item.codigo_produto == data.codigo_produto &&
          item.sequencia == data.sequencia &&
          item.tipo_produto == "PROD"
        ) {
          if (parseInt(e.target.value) <= parseInt(item.total_amount)) {
            item.select_amount = parseInt(e.target.value);
            item.remaining_amount = parseInt(item.total_amount);
            item.remaining_amount =
              parseInt(item.remaining_amount) - parseInt(e.target.value);

            this.state.data_product.map((obj) => {
              if (
                obj.tipo_produto == "EMB" &&
                obj.token_embalagem == item.token_embalagem
              ) {
                obj.select_amount = parseInt(e.target.value);
                obj.remaining_amount = parseInt(item.total_amount);
                obj.remaining_amount =
                  parseInt(item.remaining_amount) - parseInt(e.target.value);
              }
            });
          }
        }
      });
      this.setState({ update: true });
    }
    this.props.updated_item();
  };

  setLessAmount = (e) => {
    var data = JSON.parse(e.target.attributes.data.value);

    if (this.state.billing_type_more_than_one) {
      this.state.data_product.map((item) => {
        if (
          item.codigo_produto == data.codigo_produto &&
          item.sequencia == data.sequencia &&
          item.tipo_produto == "PROD"
        ) {
          if (parseInt(item.select_amount) > 0) {
            item.select_amount = parseInt(item.select_amount) - 1;
            item.remaining_amount = parseInt(item.remaining_amount) + 1;

            this.state.data_product.map((obj) => {
              if (
                obj.tipo_produto == "EMB" &&
                obj.token_embalagem == item.token_embalagem
              ) {
                obj.select_amount = parseInt(item.select_amount) - 1;
                obj.remaining_amount = parseInt(item.remaining_amount) + 1;
              }
            });
          }
        }
      });
      this.setState({ update: true });
    }
    this.props.updated_item();
  };

  render() {
    const { data_product } = this.state;

    return (
      <Box>
        <BillingProductsContainer>
          <TitleWithControl width={620} back={this.props.back}>
            <p>
              <strong>SELECIONE OS ITENS E A QUANTIDADE QUE DESEJA PARA</strong>{" "}
              O FATURAMENTO
            </p>
            <h1>{this.state.index_request}</h1>
          </TitleWithControl>

          <BillingProductsContainerContent>
            <BillingProductsContainerContentColumnView>
              <BillingProductsContainerContentColumnProductInfo></BillingProductsContainerContentColumnProductInfo>

              {this.props.data_request.map((data) => {
                if (data.tipo_produto != "EMB") {
                  if (data.token_embalagem == null) {
                    return (
                      <BillingProductsContainerContentColumnViewCel>
                        <BillingProductsContainerContentColumnViewCelPDF>
                          <BillingProductsContainerContentColumnViewCelPDFContent>
                            <span className="icon icon-30 icon-pdf-orange"></span>
                            <p>
                              Visualizar
                              <br />
                              Layout
                            </p>
                          </BillingProductsContainerContentColumnViewCelPDFContent>
                        </BillingProductsContainerContentColumnViewCelPDF>
                      </BillingProductsContainerContentColumnViewCel>
                    );
                  } else {
                    return (
                      <BillingProductsContainerContentColumnViewCelDouble>
                        <BillingProductsContainerContentColumnViewCelPDF>
                          <BillingProductsContainerContentColumnViewCelPDFContent>
                            <span className="icon icon-30 icon-pdf-orange"></span>
                            <p>
                              Visualizar
                              <br />
                              Layout
                            </p>
                          </BillingProductsContainerContentColumnViewCelPDFContent>
                        </BillingProductsContainerContentColumnViewCelPDF>
                        <BillingProductsContainerContentColumnViewCelPDF>
                          <BillingProductsContainerContentColumnViewCelPDFContent>
                            <span className="icon icon-30 icon-pdf-orange"></span>
                            <p>
                              Visualizar
                              <br />
                              Layout
                            </p>
                          </BillingProductsContainerContentColumnViewCelPDFContent>
                        </BillingProductsContainerContentColumnViewCelPDF>
                      </BillingProductsContainerContentColumnViewCelDouble>
                    );
                  }
                }
              })}
            </BillingProductsContainerContentColumnView>
            <BillingProductsContainerContentColumnProduct>
              <BillingProductsContainerContentColumnProductInfo>
                <BillingProductsContainerContentColumnProductInfoTitle>
                  <p>
                    <strong>Saida da mercadoria:</strong> 11/11/2021
                  </p>
                </BillingProductsContainerContentColumnProductInfoTitle>
              </BillingProductsContainerContentColumnProductInfo>

              {this.props.data_request.map((data) => {
                if (data.tipo_produto != "EMB") {
                  var split_data = data.url_seo.split("-");
                  split_data.pop();
                  var url = split_data.join("-");
                  var img =
                    "https://innovationbrindes.com.br/images/produtos/" +
                    data.referencia
                      .toString()
                      .substr(data.referencia.length - 4) +
                    "/" +
                    url +
                    "-1-1.jpg";

                  if (data.token_embalagem == null) {
                    return (
                      <BillingProductsContainerContentColumnProductCel>
                        <BillingProductsContainerContentColumnProductCelProd>
                          <BillingProductsContainerContentColumnProductCelProdImage>
                            <img alt="imagem" src={img} />
                          </BillingProductsContainerContentColumnProductCelProdImage>
                          <BillingProductsContainerContentColumnProductCelProdDesc>
                            <h1>
                              {data.nome_produto.trim()} - {data.referencia}
                            </h1>
                            <p>
                              Cor: {data.descricao_cor}, Gravação:{" "}
                              {data.descricao_impressao},<br />
                              Impressões: {data.qtd_batida}, Prazo de produção:{" "}
                              {data.id_prazo_entrega} dias úteis
                            </p>
                          </BillingProductsContainerContentColumnProductCelProdDesc>
                        </BillingProductsContainerContentColumnProductCelProd>
                      </BillingProductsContainerContentColumnProductCel>
                    );
                  } else {
                    if (
                      data.codigo_impressao_embalagem_selecionada
                        .descricao_impressao != undefined
                    ) {
                      var imgEmb =
                        data.codigo_impressao_embalagem_selecionada
                          .descricao_impressao == "BOX PRINT"
                          ? data.codigo_cor_embalagem_selecionada.imagem_box
                          : data.codigo_impressao_embalagem_selecionada
                              .descricao_impressao == "LOCALIZADA"
                          ? data.codigo_cor_embalagem_selecionada.imagem_print
                          : data.codigo_cor_embalagem_selecionada.imagem_plus +
                            "plus/plus1.jpg";

                      return (
                        <BillingProductsContainerContentColumnProductCelDouble>
                          <BillingProductsContainerContentColumnProductCelProd>
                            <BillingProductsContainerContentColumnProductCelProd>
                              <BillingProductsContainerContentColumnProductCelProdImage>
                                <img alt="imagem" src={img} />
                              </BillingProductsContainerContentColumnProductCelProdImage>
                              <BillingProductsContainerContentColumnProductCelProdDesc>
                                <h1>
                                  {data.nome_produto.trim()} - {data.referencia}
                                </h1>
                                <p>
                                  Cor: {data.descricao_cor}, Gravação:{" "}
                                  {data.descricao_impressao},<br />
                                  Impressões: {data.qtd_batida}, Prazo de
                                  produção: {data.id_prazo_entrega} dias úteis
                                </p>
                              </BillingProductsContainerContentColumnProductCelProdDesc>
                            </BillingProductsContainerContentColumnProductCelProd>
                          </BillingProductsContainerContentColumnProductCelProd>
                          <BillingProductsContainerContentColumnProductCelProd>
                            <BillingProductsContainerContentColumnProductCelProdImage>
                              <img
                                alt="imagemEmb"
                                src={
                                  "https://innovationbrindes.com.br/images/embalagem/" +
                                  imgEmb
                                }
                              />
                            </BillingProductsContainerContentColumnProductCelProdImage>
                            <BillingProductsContainerContentColumnProductCelProdDesc>
                              <h1>EMBALAGEM</h1>
                              <p>
                                {
                                  data.codigo_impressao_embalagem_selecionada
                                    .descricao_impressao
                                }
                                , Cor:{" "}
                                {
                                  data.codigo_cor_embalagem_selecionada
                                    .descricao_cor
                                }
                              </p>
                            </BillingProductsContainerContentColumnProductCelProdDesc>
                          </BillingProductsContainerContentColumnProductCelProd>
                        </BillingProductsContainerContentColumnProductCelDouble>
                      );
                    }
                  }
                }
              })}
            </BillingProductsContainerContentColumnProduct>
            <BillingProductsContainerContentColumnConfig>
              <BillingProductsContainerContentColumnProductInfo>
                <BillingProductsContainerContentColumnInfoTable>
                  <table>
                    <thead>
                      <th>
                        Quantidade
                        <br />
                        total
                      </th>
                      {this.state.billing_type_more_than_one ?
                        <>
                          <th>
                            Quantidade para
                            <br />
                            essa fatura
                          </th>
                          <th>
                            Quantidade
                            <br />
                            restantes
                          </th>
                        </> : <></>
                      }
                      
                      <th>
                        Valores
                        <br />
                        unitários
                      </th>
                      <th>ST</th>
                      <th>Subtotal</th>
                    </thead>
                  </table>
                </BillingProductsContainerContentColumnInfoTable>
              </BillingProductsContainerContentColumnProductInfo>

              {this.props.data_request.map((data) => {
                if (data.tipo_produto != "EMB") {
                  if (data.token_embalagem == null) {
                    if (data.codigo_produto == "436") {
                      console.log(data);
                    }

                    return (
                      <BillingProductsContainerContentColumnConfigCel>
                        <BillingProductsContainerContentColumnConfigCelConfig>
                          <BillingProductsContainerContentColumnConfigCelConfigTable>
                            <table>
                              <tbody>
                                
                                <td>
                                  <h1>
                                    {this.state.data_proposal_original.map(
                                      (item) => {
                                        if (item.codigo_produto == data.codigo_produto && item.sequencia == data.sequencia) {
                                          return parseInt(item.qtd_negociada);
                                        }
                                      }
                                    )}
                                  </h1>
                                </td>


                                {this.state.billing_type_more_than_one ?
                                  <>
                                    <td>
                                      <BillingProductsContainerContentColumnConfigCelConfigTableControlQuantidade>
                                        <span
                                          data={JSON.stringify({
                                            codigo_produto: data.codigo_produto,
                                            sequencia: data.sequencia,
                                          })}
                                          onClick={(e) => this.setLessAmount(e)}
                                        >
                                          -
                                        </span>
                                        <input
                                          data={JSON.stringify({
                                            codigo_produto: data.codigo_produto,
                                            sequencia: data.sequencia,
                                          })}
                                          value={data.select_amount}
                                          onChange={(e) => this.setAmount(e)}
                                          type="text"
                                        />
                                        <span
                                          data={JSON.stringify({
                                            codigo_produto: data.codigo_produto,
                                            sequencia: data.sequencia,
                                          })}
                                          onClick={(e) => this.setMoreAmount(e)}
                                        >
                                          +
                                        </span>
                                      </BillingProductsContainerContentColumnConfigCelConfigTableControlQuantidade>
                                    </td>
                                    <td>
                                      <h1 class="cyan">
                                        {/* {parseInt(data.total_amount) - parseInt(data.select_amount)} */}
                                        {parseInt(data.remaining_amount)}
                                      </h1>
                                    </td>
                                  </> : <></>
                                }

                                
                                <td>
                                  <p>
                                    {parseFloat(
                                      data.valor_unitario
                                    ).toLocaleString("pt-BR", {
                                      style: "currency",
                                      currency: "BRL",
                                    })}
                                  </p>
                                </td>
                                <td>
                                  <p>R$ 0,00</p>
                                </td>
                                <td>
                                  <p>
                                    {parseFloat(data.valor_unitario * data.select_amount).toLocaleString("pt-BR", {
                                      style: "currency",
                                      currency: "BRL",
                                    })}
                                  </p>
                                </td>
                              </tbody>
                            </table>
                          </BillingProductsContainerContentColumnConfigCelConfigTable>
                        </BillingProductsContainerContentColumnConfigCelConfig>
                      </BillingProductsContainerContentColumnConfigCel>
                    );
                  } else {
                    return (
                      <BillingProductsContainerContentColumnConfigCelDouble>
                        <BillingProductsContainerContentColumnConfigCelConfigMargin>
                          <BillingProductsContainerContentColumnConfigCelConfigTable>
                            <table>
                              <tbody>
                                <td>
                                  <h1>
                                    {this.state.data_proposal_original.map(
                                      (item) => {
                                        if (
                                          item.codigo_produto ==
                                            data.codigo_produto &&
                                          item.sequencia == data.sequencia
                                        ) {
                                          return parseInt(item.qtd_negociada);
                                        }
                                      }
                                    )}
                                  </h1>
                                </td>
                                <td>
                                  <BillingProductsContainerContentColumnConfigCelConfigTableControlQuantidade>
                                    <span
                                      data={JSON.stringify({
                                        codigo_produto: data.codigo_produto,
                                        sequencia: data.sequencia,
                                      })}
                                      onClick={(e) => this.setLessAmount(e)}
                                    >
                                      -
                                    </span>
                                    <input
                                      data={JSON.stringify({
                                        codigo_produto: data.codigo_produto,
                                        sequencia: data.sequencia,
                                      })}
                                      value={data.select_amount}
                                      onChange={(e) => this.setAmount(e)}
                                      type="text"
                                    />
                                    <span
                                      data={JSON.stringify({
                                        codigo_produto: data.codigo_produto,
                                        sequencia: data.sequencia,
                                      })}
                                      onClick={(e) => this.setMoreAmount(e)}
                                    >
                                      +
                                    </span>
                                  </BillingProductsContainerContentColumnConfigCelConfigTableControlQuantidade>
                                </td>
                                <td>
                                  <h1 class="cyan">
                                    {parseInt(data.remaining_amount)}
                                    {/* {parseInt(data.total_amount) - parseInt(data.select_amount)} */}
                                  </h1>
                                </td>
                                <td>
                                  <p>
                                    {parseFloat(
                                      data.valor_unitario
                                    ).toLocaleString("pt-BR", {
                                      style: "currency",
                                      currency: "BRL",
                                    })}
                                  </p>
                                </td>
                                <td>
                                  <p>R$ 0,00</p>
                                </td>
                                <td>
                                  <p>
                                    {parseFloat(
                                      data.valor_total
                                    ).toLocaleString("pt-BR", {
                                      style: "currency",
                                      currency: "BRL",
                                    })}
                                  </p>
                                </td>
                              </tbody>
                            </table>
                          </BillingProductsContainerContentColumnConfigCelConfigTable>
                        </BillingProductsContainerContentColumnConfigCelConfigMargin>
                        <BillingProductsContainerContentColumnConfigCelConfig>
                          <BillingProductsContainerContentColumnConfigCelConfigTable>
                            <table>
                              <tbody>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td>
                                  <p>
                                    {parseFloat(
                                      data.dados_embalagem.valor_unitario
                                    ).toLocaleString("pt-BR", {
                                      style: "currency",
                                      currency: "BRL",
                                    })}
                                  </p>
                                </td>
                                <td>
                                  <p>R$ 0,30</p>
                                </td>
                                <td>
                                  <p>
                                    {parseFloat(
                                      parseFloat(
                                        data.dados_embalagem.valor_unitario
                                      ) * parseInt(data.qtd_negociada)
                                    ).toLocaleString("pt-BR", {
                                      style: "currency",
                                      currency: "BRL",
                                    })}
                                  </p>
                                </td>
                              </tbody>
                            </table>
                          </BillingProductsContainerContentColumnConfigCelConfigTable>
                        </BillingProductsContainerContentColumnConfigCelConfig>
                      </BillingProductsContainerContentColumnConfigCelDouble>
                    );
                  }
                }
              })}
            </BillingProductsContainerContentColumnConfig>
          </BillingProductsContainerContent>

          <ButtonContinue onClick={this.props.continue} />
        </BillingProductsContainer>
      </Box>
    );
  }
}

export default BillingProducts;
